import { NgIf } from '@angular/common';
import { Directive, Input, OnChanges } from '@angular/core';
import { NgInject } from '@df/ng/ng-inject';
import { Acl, IAuthAcl } from '@df/core/service/acl';

/**
 * Use this directive to present element only in developer mode.
 *
 * ```html
 * <div *ifDev>...</div>
 * ```
 */
@Directive({
    selector: '[ifAcl]',
    standalone: true
})
export class IfAclDirective extends NgIf implements OnChanges {
    @Input({
        required: true
    })
    ifAcl!: string | keyof IAuthAcl | (keyof IAuthAcl)[];

    @NgInject(Acl)
    private acl!: Acl;

    /**
     * Sets condition depending on user being developer.
     *
     * @memberof IfDevDirective
     */
    ngOnChanges() {
        this.ngIf = this.check();
    }

    private check() {
        if (!this.ifAcl) {
            return true;
        } else if (Array.isArray(this.ifAcl)) {
            return !!this.ifAcl.find(i => this.acl.check(i));
        } else {
            let rule = this.ifAcl;
            const invert = rule[0] === '!';
            if (invert) {
                rule = rule.substring(1);
            }
            return this.acl.check(<keyof IAuthAcl>rule) ? !invert : invert;
        }
    }
}
